
import { defineComponent } from '@nuxtjs/composition-api';
import ContactUsForm from '~/domains/contact-us/components/ContactUsForm';
import { getOptimizedImage } from '~/helpers/getOptimizedImage';

export default defineComponent({
  name: 'ContactUsFormSection',
  components: { ContactUsForm },
  props: {
    image: {
      type: Object,
      default: () => ({}),
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    note: {
      type: String,
      default: '',
    },
  },
  setup() {
    return { getOptimizedImage };
  },
});
